"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _ = require(".");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Build the React components and mount them in the view at selectors.
 *
 * @param {Object} view
 * @param {Object} components
 * @param {function} buildEnhancedComponent
 * @param {function} render
 * @returns {array}
 */
var buildComponents = function (view, components, buildEnhancedComponent, render) {
  if (buildEnhancedComponent === void 0) {
    buildEnhancedComponent = _.buildEnhancedComponent;
  }

  if (render === void 0) {
    render = _reactDom.render;
  }

  return Object.keys(components).map(function (selector) {
    var el = (0, _.getEl)(view, selector);
    var builder = (0, _.getBuilder)(components, selector);

    if (!el || !builder) {
      return undefined;
    }

    var result = (0, _.evaluateBuilder)(builder, view);

    if (!result) {
      return undefined;
    }

    if (result && (_react.default.isValidElement(result) || result.component)) {
      render(buildEnhancedComponent(result), el);
    } else {
      return undefined;
    }

    return el;
  }).filter(function (el) {
    return !!el;
  });
};

var _default = buildComponents;
exports.default = _default;